import { render, staticRenderFns } from "./ReNewCourseInfor.vue?vue&type=template&id=6ffa0f75"
import script from "./ReNewCourseInfor.vue?vue&type=script&lang=js"
export * from "./ReNewCourseInfor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports